import React from 'react';
import { useTranslation } from "react-i18next";
import { Card, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './style.css'

const TablePolynomyItemNotAdjustment = ({totalRestAdjustmentAmount, addCardWidth = false}) => {
    const { t } = useTranslation();

    return (
        <Col xl={6}>
            <Card className={'polinomio poliGris m-1 ' + (addCardWidth ? 'w-20' : 'w-100')}>
                <Card.Body>
                    <Row>
                    <Col>
                        <Row><Col>{t('data-lang-lbl-notadjustment')}</Col></Row>
                    </Col>
                    <Col style={{fontSize: "30px"}}>{totalRestAdjustmentAmount}%</Col>
                    </Row>
                </Card.Body>
            </Card>
        </Col>
    );
};

TablePolynomyItemNotAdjustment.propTypes = {
    totalRestAdjustmentAmount: PropTypes.number.isRequired,
};

export default TablePolynomyItemNotAdjustment;